if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.credentials = 'same-origin';

        const formData = new FormData(this.form);
        const cartAddUrl = routes.cart_add_url.endsWith('.js')
          ? routes.cart_add_url
          : `${routes.cart_add_url}.js`;
        const usesAddJs = cartAddUrl.endsWith('.js');

        if (!usesAddJs && this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }

        if (this.cart && typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            const renderCart = (cartResponse) => {
              if (!this.cart) return Promise.resolve();
              if (typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(cartResponse);
                return Promise.resolve();
              }

              if (this.cart?.tagName === 'CART-DRAWER') {
                return customElements.whenDefined('cart-drawer').then(() => {
                  this.cart.renderContents(cartResponse);
                });
              }

              if (this.cart?.tagName === 'CART-NOTIFICATION') {
                return customElements.whenDefined('cart-notification').then(() => {
                  this.cart.renderContents(cartResponse);
                });
              }

              return Promise.resolve();
            };

            const updateCartUI = () => {
              if (!this.cart || !usesAddJs || typeof this.cart.getSectionsToRender !== 'function') {
                return renderCart(response);
              }

              const sectionIds = this.cart.getSectionsToRender().map((section) => section.id).join(',');
              const sectionsUrl = `${routes.cart_url}?sections=${sectionIds}&sections_url=${encodeURIComponent(
                window.location.pathname
              )}`;
              return fetch(sectionsUrl, { credentials: 'same-origin' })
                .then((sectionResponse) => sectionResponse.json())
                .then((sectionsHtml) => {
                  response.sections = sectionsHtml;
                  return renderCart(response);
                })
                .catch(() => {
                  return renderCart(response);
                });
            };

            const publishCartUpdate = () => {
              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }
            };

            if (quickAddModal) {
              return new Promise((resolve) => {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      resolve(updateCartUI());
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              }).then(publishCartUpdate);
            } else {
              return updateCartUI().then(publishCartUpdate);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
